import * as React from "react";

const SvgPaginationArrowLeft = props => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.21899 7.33361H13.3337V8.66694H5.21899L8.79499 12.2429L7.85232 13.1856L2.66699 8.00027L7.85232 2.81494L8.79499 3.75761L5.21899 7.33361Z" fill="#F8F8F8" /></svg>;

export default SvgPaginationArrowLeft;